<template>
  <path
    id="ic_mic_24px"
    d="M10.895,12.105a2.516,2.516,0,0,0,2.518-2.526l.008-5.053a2.526,2.526,0,0,0-5.053,0V9.579A2.523,2.523,0,0,0,10.895,12.105Zm4.463-2.526a4.369,4.369,0,0,1-4.463,4.295A4.369,4.369,0,0,1,6.432,9.579H5a5.881,5.881,0,0,0,5.053,5.659V18h1.684V15.238a5.867,5.867,0,0,0,5.053-5.659Z"
    transform="translate(-5 -2)" />
</template>
